// extracted by mini-css-extract-plugin
export default {"promoCodesForm":"PromoCode_promoCodesForm__B6P7M","buttonContainer":"PromoCode_buttonContainer__3LZjY"};